// TodayStats.js — Displays today's worked/late/OT/expected-out stats
import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  AccessTime as TimeIcon,
  Warning as LateIcon,
  TrendingUp as OtIcon,
  Schedule as OutIcon,
} from '@mui/icons-material';

const pad2 = (n) => String(n).padStart(2, '0');

const toHM = (min) => {
  if (!min || min <= 0) return null;
  return `${Math.floor(min / 60)}h ${pad2(min % 60)}m`;
};

/**
 * @param {object} todayRow - attendance_days row for today
 * @param {string} expectedOut - expected punch-out time (HH:MM) from schedule
 */
export default function TodayStats({ todayRow, expectedOut }) {
  if (!todayRow) return null;

  const worked = toHM(todayRow.worked_min);
  const late = todayRow.late_min > 0 ? `${todayRow.late_min} min` : null;
  const earlyOut = todayRow.early_out_min > 0 ? `${todayRow.early_out_min} min` : null;
  const ot = todayRow.payable_ot_min > 0 ? `${(todayRow.payable_ot_min / 60).toFixed(1)}h` : null;

  const stats = [
    worked && { icon: <TimeIcon sx={{ fontSize: 14, color: 'primary.main' }} />, label: 'Worked', value: worked },
    late && { icon: <LateIcon sx={{ fontSize: 14, color: 'warning.main' }} />, label: 'Late', value: late, color: 'warning.main' },
    earlyOut && { icon: <LateIcon sx={{ fontSize: 14, color: 'warning.main' }} />, label: 'Early Out', value: earlyOut, color: 'warning.main' },
    ot && { icon: <OtIcon sx={{ fontSize: 14, color: 'success.main' }} />, label: 'OT', value: ot },
    expectedOut && { icon: <OutIcon sx={{ fontSize: 14, color: 'text.secondary' }} />, label: 'Out by', value: expectedOut },
  ].filter(Boolean);

  if (stats.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: 1 }}>
      {stats.map((s, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {s.icon}
          <Typography variant="caption" color="text.secondary">{s.label}</Typography>
          <Typography variant="caption" fontWeight={600} sx={{ color: s.color || 'text.primary' }}>{s.value}</Typography>
        </Box>
      ))}
    </Box>
  );
}
